import type { TpWindow } from '@features/Unsubscribe/types';

const CLOSE_WEB_VIEW_MESSAGE = 'closeWebView';

export const closeWebView = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    const messageHandler = (window as TpWindow).webkit?.messageHandlers
      ?.jsMessageHandler;

    if (typeof messageHandler?.postMessage !== 'function') {
      return false;
    }

    messageHandler.postMessage(CLOSE_WEB_VIEW_MESSAGE);
    return true;
  } catch (error) {
    console.warn('Failed to close WebView', error);
    return false;
  }
};
